<div
  class="border rounded shadow text-color-blue1 flex w-auto md:w-[600px] h-full p-4 gap-4 flex-col md:flex-row"
     *transloco="let t; read 'customer.saved_power_plants.plant';">
  <div class="w-auto md:w-[340px] h-[200px] md:h-auto rounded bg-center bg-cover bg-no-repeat"
       [style.background-image]="'url(' + (powerPlant.locationPicture ? ('data:image/jpg;base64,' + powerPlant.locationPicture) : 'assets/images/solar-panels-roof-green.webp') + ')'">
  </div>
  <div class="w-full flex flex-col gap-3 justify-around">
    <div>
      <div class="flex justify-between items-center">
        <h2 class="w-[340px] whitespace-nowrap mr-3 overflow-ellipsis overflow-hidden">{{powerPlant.projectName}}</h2>
        <mat-icon
          (click)="deletePowerPlant(powerPlant.analysisId)"
          class="text-color-magenta cursor-pointer hover:opacity-60">delete
        </mat-icon>
      </div>
      <psc-line></psc-line>
    </div>
    <div class="flex gap-1">
      <mat-icon>location_on</mat-icon>
      <div>
        {{powerPlant.address}}
      </div>
    </div>
    <div class="flex flex-col">
      <div class="{{rowClass}}">
        <div>{{t('effectiveness')}}</div>
        <div>{{powerPlant.selfSufficiencyPercentage | number:'1.0-0'}}%</div>
      </div>

      <div class="{{rowClass}}">
        <div>{{t('power')}}</div>
        <div>{{powerPlant.systemCapacity | number:'1.0-2'}} kWh</div>
      </div>

      <div class="{{rowClass}}">
        <div>{{t('area')}}</div>
        <div>{{powerPlant.area | number:'1.0-0'}} m2</div>
      </div>
    </div>
    <div class="flex">
      <psc-button
        size="small"
        [routerLink]="['/customer/power-plant', powerPlant.analysisId]"
        [label]="t('details')"></psc-button>
    </div>
  </div>
</div>
